export function videoDialog() {
    const videoTriggers = document.querySelectorAll('.has-play-icon');
    if (!videoTriggers.length) return;

    for (const videoTrigger of videoTriggers) {
        const figure = videoTrigger.closest('figure');
        const dialog = figure?.contains(videoTrigger)
            ? figure.nextElementSibling
            : videoTrigger.parentElement.querySelector('dialog');

        if (!dialog) continue;

        const iframe = dialog.querySelector('iframe');
        if (!iframe) continue;

        const closeButton = dialog.querySelector('.dialog-close');
        if (!closeButton) continue;

        const originalSrc = iframe.getAttribute('src');
        const autoplaySrc = `${originalSrc}${originalSrc.includes('?') ? '&' : '?'}autoplay=1`;

        videoTrigger.addEventListener('click', () => {
            iframe.src = autoplaySrc;
            dialog.showModal();
        });

        closeButton.addEventListener('click', () => {
            iframe.src = originalSrc;
            dialog.close();
        });

        dialog.addEventListener('close', () => {
            iframe.src = originalSrc;
        });
    }
}